/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyFigmaIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-figma" */ './utils').then((m) => m.FigmaIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/figma/icon' },
);

const LazyFigmaSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-figma-search-result" */ './utils').then(
			(m) => m.FigmaSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/figma/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const FigmaIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyFigmaIconComponent />
	</Suspense>
);

export const FigmaSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyFigmaSearchResultIconComponent />
	</Suspense>
);
